export const SupplierColumns = [
  {
    id: "actions",
    title: "Actions",
    type: "entity-menu",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "address",
    title: "Address",
  },
  {
    id: "description",
    title: "Description",
  },
  {
    id: "total",
    title: "Total",
  },
  {
    id: "paid",
    title: "Paid",
  },
  {
    id: "discount",
    title: "Discount",
  },
  {
    id: "payable",
    title: "Remaining",
  },
];
